import { axios } from '@/utils/request'

export function queryAdSpendReport (parameter = {}) {
  return axios({
    url: '/statistics/adSpend/list',
    method: 'post',
    data: parameter
  })
}